import { format } from "date-fns"
import { type TaskCategory } from "@/features/tasks/api/task-categories-api.ts"
import { type Task } from "@/features/tasks/types/task.ts"

export const getTaskDateHour = (task: Task) => {
  if (!task.due_date) return { formattedDate: "", formattedHour: "" }
  const date = new Date(task.due_date)
  return {
    formattedDate: format(date, "dd.MM.yyyy"),
    formattedHour: format(date, "HH:mm"),
  }
}

export const getCategoryForTask = (
  task: Task,
  categories: TaskCategory[],
): TaskCategory | undefined =>
  categories.find((category) => category.id === task.category)
